import { render, staticRenderFns } from "./DEGdetail.vue?vue&type=template&id=5aab3c56&scoped=true"
import script from "./DEGdetail.vue?vue&type=script&lang=js"
export * from "./DEGdetail.vue?vue&type=script&lang=js"
import style0 from "./DEGdetail.vue?vue&type=style&index=0&id=5aab3c56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aab3c56",
  null
  
)

export default component.exports